module.exports = __webpack_public_path__ + "static/media/3.87ff362e.svg";